import { RawDraftContentState } from "draft-js";

type Props = (state?: RawDraftContentState) => string;

const getPlainText: Props = (state) => {
  return state ? state.blocks.reduce((prev, x) => prev + x.text, "") : "";
};

export default getPlainText;
